export const handleize = (string) => {
    return string.toLowerCase().replace(/ /g, '-');
};
export const randomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1 + min));
};
export const encodeDataToURL = (data) => {
    return Object.keys(data)
        .map((value) => `${value}=${encodeURIComponent(data[value])}`)
        .join('&');
};
export const formattedCurrency = (amount, locale = window.theme.locale, currency = window.theme.currency) => {
    const amountFormatted = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol', compactDisplay: 'long' }).format(amount / 100);
    return `${amountFormatted} ${currency}`;
};
export const formattedMoney = (amount, locale = window.theme.locale, currency = window.theme.currency) => {
    const amountFormatted = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'narrowSymbol', compactDisplay: 'long' }).format(amount / 100);
    return `${amountFormatted}`;
};
export const expandElement = (element) => {
    const sectionHeight = element.scrollHeight;
    element.style.height = sectionHeight + 'px';
    function removeHeightAttribute() {
        element.style.height = 'auto';
        element.removeEventListener('transitionend', removeHeightAttribute);
    }
    element.addEventListener('transitionend', removeHeightAttribute);
};
export const collapseElement = (element) => {
    const sectionHeight = element.scrollHeight;
    const elementTransition = element.style.transition;
    element.style.transition = '';
    requestAnimationFrame(() => {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;
        requestAnimationFrame(() => {
            element.style.height = 0 + 'px';
        });
    });
};
// TODO: Fix lint errors for file. Linting disabled in the interim.
/* eslint-disable */
let currentScrollTop;
export const lockBody = () => {
    currentScrollTop = window.pageYOffset;
    document.body.classList.add('locked');
    document.body.style.top = `-${currentScrollTop}px`;
};
export const unlockBody = () => {
    document.body.classList.remove('locked');
    document.body.style.top = '';
    requestAnimationFrame(() => {
        document.documentElement.style.setProperty('scroll-behavior', 'auto');
        window.scrollTo({ top: currentScrollTop, behavior: 'auto' });
        document.documentElement.style.removeProperty('scroll-behavior');
    });
};
export const setURLParam = (key, value) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    urlParams.searchParams.set(key, value);
    history.pushState({}, '', urlParams);
};
export const deletURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    urlParams.searchParams.delete(key);
    history.pushState({}, '', urlParams);
};
export const getURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    return urlParams.searchParams.get(key);
};
export const getAllURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    return urlParams.searchParams.getAll(key);
};
